import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import StudentDashboard from "./pages/Student/StudentDashBoard";
import Login from "./pages/Login";
import AdminLogin from "./pages/SuperAdmin/AdminLogin";
import AdminLayout from "./pages/SuperAdmin/AdminLayout";
import StudentTimetable from "./pages/Student/StudentTimetable";
import Layout from "./pages/StudentLayout";
import StudentAlmanac from "./pages/Student/StudentAlmanac";
import Attendance from "./pages/Faculty/Attendance";
import DocVault from "./pages/DocVault";
import AdminDashboard from "./pages/SuperAdmin/AdminDashboard";
import AddUserCurr from "./pages/SuperAdmin/AddUserCurr";
import Error404 from "./pages/Error-404";
import FacultyDashboard from "./pages/Faculty/FacultyDashboard";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Unauthorized from "./pages/Unauthorized";
import CoursesList from "./pages/Student/CoursesList";
import CoursePage from "./pages/Student/CoursePage";
import QAEManagement from "./pages/Faculty/QAEManagement";
import Courses from "./pages/SuperAdmin/Courses";
import Faculty from "./pages/SuperAdmin/Faculty";
import Student from "./pages/SuperAdmin/Student";
import AddCourse from "./pages/SuperAdmin/AddCourse";
import EditDetails from "./components/SuperAdmin/EditDetails";
import CoursesAttendance from "./pages/Student/CoursesAttendance";
import FTicketTable from "./pages/Faculty/PendingTickets";
import ScoresList from "./pages/Faculty/ScoresList";
import AttendanceList from "./pages/Faculty/AttendanceList";
import Quizzes from "./pages/Faculty/Quizzes";
import Assignments from "./pages/Faculty/Assignments";
import Exams from "./pages/Faculty/Exams";

const RoutesComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = sessionStorage.getItem("isAuthenticated");

  useEffect(() => {
    if (isAuthenticated) {
      sessionStorage.setItem("lastRoute", location.pathname);
    }
  }, [location, isAuthenticated]);

  useEffect(() => {
    const lastRoute = sessionStorage.getItem("lastRoute");
    const actualRole = localStorage.getItem("type");
    const pathname = location.pathname;
    const parts = pathname.split("/").filter(Boolean);
    const role = parts[0];
    if (role && actualRole && isAuthenticated) {
      if (isAuthenticated && lastRoute && role === actualRole) {
        navigate(lastRoute);
      } else if (role !== actualRole) {
        navigate("/unauthorized");
      }
    } else {
      if (!isAuthenticated) {
        navigate("/");
      }
    }
  }, [isAuthenticated]);

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/admin/login" element={<AdminLogin />} />

      {/* Admin Routes */}
      <Route path="/admin/*" element={<AdminLayout />}>
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="tickets" element={<FTicketTable />} />
        <Route path="student" element={<Student />} />
        <Route path="student/add" element={<AddUserCurr type="student" />} />
        <Route path="student/edit/:id" element={<EditDetails type="student" />} />
        <Route path="faculty" element={<Faculty />} />
        <Route path="faculty/add" element={<AddUserCurr type="faculty" />} />
        <Route path="faculty/edit/:id" element={<EditDetails type="faculty" />} />
        <Route path="courses" element={<Courses />} />
        <Route path="courses/add" element={<AddCourse />} />
        <Route path="docVault" element={<DocVault />} />
        <Route exact path="docvault/:folderPath/*" element={<DocVault />} />
        <Route path="*" element={<Error404 />} />
      </Route>

      {/* Student Routes */}
      <Route path="/student/*" element={<Layout />}>
        <Route path="dashboard" element={<StudentDashboard />} />
        <Route path="attendance" element={<CoursesAttendance />} />
        <Route exact path="docvault" element={<DocVault />} />
        <Route exact path="docvault/:folderPath/*" element={<DocVault />} />
        <Route path="timetable" element={<StudentTimetable />} />
        <Route path="almanac" element={<StudentAlmanac />} />
        <Route path="scores" element={<CoursesList />} />
        <Route path="scores/:courseid" element={<CoursePage />} />
        <Route path="*" element={<Error404 />} />
      </Route>

      {/* Faculty Routes */}
      <Route path="/faculty/*" element={<Layout />}>
        <Route path="dashboard" element={<FacultyDashboard />} />
        <Route path="attendance" element={<AttendanceList />} />
        <Route path="attendance/:courseId" element={<Attendance />} />
        <Route exact path="docvault" element={<DocVault />} />
        <Route exact path="docvault/:folderPath/*" element={<DocVault />} />
        <Route path="timetable" element={<StudentTimetable />} />
        <Route path="almanac" element={<StudentAlmanac />} />
        <Route path="scores" element={<ScoresList />} />
        <Route path="scores/:courseId" element={<QAEManagement />} />
        <Route path="scores/:courseId/quizzes" element={<Quizzes />} />
        <Route path="scores/:courseId/assignments" element={<Assignments />} />
        <Route path="scores/:courseId/exams" element={<Exams />} />
        <Route path="*" element={<Error404 />} />
      </Route>

      {/* Other Routes */}
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <RoutesComponent />
    </Router>
  );
}

export default App;
